/**
 * 应用路由等常量，便于统一维护与扩展
 */

/** 登录页路径 */
export const LOGIN_PATH = '/user/login'

/** 默认首页路径 */
export const DEFAULT_HOME_PATH = '/'

/** 单菜单（如仅视频控制）时的重定向路径 */
export const VIDEO_CONTROL_SINGLE_MENU_PATH = '/control/videoControl'
